import { render, staticRenderFns } from "./file-upload-modal.vue?vue&type=template&id=be84f656"
import script from "./file-upload-modal.vue?vue&type=script&lang=ts"
export * from "./file-upload-modal.vue?vue&type=script&lang=ts"
import style0 from "./file-upload-modal.vue?vue&type=style&index=0&id=be84f656&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports